<div class="optimization-wrapper">
  <div class="optimization-coloading">
    <ng-container
      [ngTemplateOutlet]="voyageHeader"
      [ngTemplateOutletContext]="{ isColoading: true, voyageRefNumber: voyage.referenceNumber }"
    ></ng-container>

    <div class="optimization-containers-items is-coloading">
      <optimization-view-container
        [totalBooked]="totalBookedColoading"
        [containerType]="defaultContainerType"
        [voyage]="voyage"
        [container]="defaultContainer"
      ></optimization-view-container>
    </div>

    <voyage-shipments-table
      [isColoading]="true"
      [isShowCheckbox]="true"
      [shipments]="containerShipments(defaultContainerId)"
      [container]="defaultContainer"
      (checkboxChecked)="onCheckboxChecked($event, defaultContainerId)"
      (moveShipmentSource)="moveShipment($event)"
    ></voyage-shipments-table>
  </div>

  <div class="optimization-containers">
    <div class="optimization-containers-header">
      <ng-container
        [ngTemplateOutlet]="voyageHeader"
        [ngTemplateOutletContext]="{ isColoading: false, voyageRefNumber: voyage.referenceNumber }"
      ></ng-container>

      <div class="optimization-containers-arrow-left" *ngIf="nonDefaultContainers.length">
        <img src="assets/icons/icon_right.svg" (click)="saveContainersOptimization(defaultContainerId)" />
      </div>
    </div>

    <div class="optimization-containers-items">
      <ng-container *ngFor="let containerType of nonDefaultContainerType">
        <optimization-view-container
          [totalBooked]="getContainerOpenBoxSum(containerType.id)"
          [containerType]="containerType"
          [voyage]="voyage"
          (create)="createContainer.emit(containerType.id)"
        ></optimization-view-container>
      </ng-container>
    </div>

    <ng-container *ngFor="let container of nonDefaultContainers">
      <div class="optimization-containers-item">
        <div
          class="optimization-containers-arrow-right"
          *ngIf="containerShipments(defaultContainerId).length"
          (click)="saveContainersOptimization(container.id)"
        >
          <img src="assets/icons/icon_right.svg" />
        </div>
        <voyage-shipments-table
          [isColoading]="false"
          [isShowCheckbox]="true"
          [isShowContainerHeader]="true"
          [isShowDelete]="!containerShipments(container.id).length"
          [shipments]="containerShipments(container.id)"
          [container]="container"
          [totalCostContainer]="getTotalCostContainer(container)"
          (checkboxChecked)="onCheckboxChecked($event, container.id)"
          (delete)="deleteContainer.emit(container.id)"
          (moveShipmentSource)="moveShipment($event)"
        ></voyage-shipments-table>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #voyageHeader let-isColoading="isColoading" let-voyageRefNumber="voyageRefNumber">
  <div class="optimization-total" [ngClass]="{ 'is-coloading': isColoading }">
    <div class="optimization-total-col">
      <h5>{{ "LABELS.VOYAGE_REF_NUM" | translate }}</h5>
      <p>{{ voyageRefNumber }} {{ (isColoading ? "C" : "LABELS.VOYAGE_REF_NUM_DRAFT_SUFFIX") | translate }}</p>
    </div>

    <div class="optimization-total-col">
      <h5>{{ "LABELS.TYPE" | translate }}</h5>
      <p>{{ (isColoading ? "LABELS.COLOADING" : "LABELS.GROUPAGE") | translate }}</p>
    </div>

    <div class="optimization-total-col">
      <h5>{{ (isColoading ? "LABELS.TOTAL_COLOADING_COST" : "LABELS.TOTAL_GROUPAGE_COST") | translate }}</h5>
      <p>{{ (isColoading ? getColoadingTotals() : getGroupageTotals()) | currency : "USD" : "symbol" : "1.2-2" }}</p>
    </div>
  </div>
</ng-template>
